export interface Region {
  Id?: number;
  HashId?: string;
  Region?: string;
  Note?: string;
  account?: string;
  otp?: string;
  RegionName?: string;
  Admins?: number[];
  Appearance?: string;
  ThemeColorCode?: string;
  EnableDomain?: boolean;
  CertRoot?: string;
  CertIntermediate?: string;
  CertWildcard?: string;
  PrivateKey?: string;
  ParentRegionId?: number;
  Domain?: string;
  IsMsp?: boolean;
  DeviceLimit?: number;
  PlanLevel?: number;
  PlanTime?: number;
  MspMainRegionId?: number;
  MainAdmin?: number;
  CreateId?: number;
  Members?: number[];
  PlanMgtId?: number;
  PlanName?: string;
  MonthlyEnable?: boolean;
  PaymentName?: string;
  PaymentAddress?: string;
  IsDistributor: boolean;
  UnitPrice: string;
  TransferAccount?: string;
  ProStatus?: number;
  OwnerAcode?: number;
  OwnerAccount?: string;
  ProActDt?: string;
  Nodes?: number;
  RegionId?: number;
  ChargeType?: number;
  LockStatus?: number;
  CanUpsCtrl?: boolean;
}

/** API 回傳之帳號物件（與字串欄位 account 並存） */
export interface MspRegionAccountInfo {
  account: string;
  acode: number;
}

export interface MspRegion {
  Id?: number;
  RegionId?: number;
  HashObj?: string;
  Region?: string;
  Note?: string;
  account?: string;
  /** 後端巢狀帳號（Customer Management 等流程使用） */
  Account?: MspRegionAccountInfo;
  CreateId?: number;
  PROType?: number;
  otp?: string;
  RegionName?: string;
  Admins?: number[];
  MainAdmin?: number;
  MSPAdmin?: string;
  EnableDomain?: boolean;
  SAMLCert?: string;
  SAMLCertFile?: string;
  ParentRegionId?: number;
  Domain?: string;
  SSOEnable?: boolean;
  SSOEntityId?: string;
  SAMLLoginURL?: string;
  Identifier?: string;
  ReplyUrl?: string;
  LoginUrl?: string;
  MspRemainingDays?: number;
  MspDeviceLimit?: number;
  MspPlanTime?: number;
  MspMainRegionId?: number;
  MspPlanLevel?: number;
  MspActivatedDevice?: number;
  MspDomain?: string;
  MspActivate?: boolean;
  MspMainAdmin?: number;
  MspRemainDay?: number;
  MspPlanMgtId?: number;
  MspPlanName?: string;
  DeviceUsage?: number;
  NpmBank?: number;
}

export interface MspAuthority {
  Id?: number;
  otp?: string;
  acode?: number;
  RegionId?: number;
  AuthRegionId?: number;
  All?: boolean;
  ViewDevice?: boolean;
  EditDevice?: boolean;
  Note?: string;
}

export interface MspDeleteData {
  acode?: number;
  RegionId?: number;
}

export interface MspAuthorityForUpdate {
  acode?: number;
  RegionId?: number;
  All?: boolean;
  ViewDevice?: boolean;
  EditDevice?: boolean;
  WeeklyReport?: boolean;
  MonthlyReport?: boolean;
  Note?: string;
}
export interface MspPaymentSetting {
  RegionId?: number;
  MspRegionId?: number;
  UnitPrice?: string;
  DocDay?: number;
  Company?: string;
  Address?: string;
  InvoiceCreateTime?: number;
  EmailInfo?: EmailInfo[];
  DocType?: number;
  IsDistributor?: boolean;
  Customers?: number[];
  MinCharge?: number;
  CompanyEmail?: string;
  SyncSetting?: boolean;
  IsReminder?: boolean;
  IsAllowLock?: boolean;
  PaymentRegionId?: number;
}
export interface EmailInfo {
  id?: number;
  Receiver?: string;
  Type?: number,
  Note?: string,
  ReceiverType?: number;
}
export interface MspDocument {
  ParentRegionId?: number;
  RegionId: number;
  DocId: number;
  DocNo?: string;
  DocDate?: string;
  DocStatus?: number;
  UnitPrice?: number;
  DeviceUsage?: number;
  CreateTime?: number;
  ClosedTime?: number;
  IsManual?: boolean;
  Usage?: Usage[];
}
export interface Usage {
  ParentRegionId?: number;
  RegionId?: number;
  DeviceUsage?: number,
  UnitPrice?: number;
}
export interface MspDeviceUsage {
  RegionId: number;
  UsageDate?: string;
  Usage?: Usage[];
}
export interface Usage {
  ParentRegionId?: number;
  RegionId?: number;
  DeviceUsage?: number
}